import React from 'react';
import catalog from '../../Images/catalog.png';
import '../../Styles/Catalog2.css';
import { useNavigate } from "react-router-dom";
import WishlistButton from "./WishlistBtn";

export default function Catalog2(props) {
  const navigate = useNavigate();

  const viewCourse = () => {
    navigate(`/Course/${props.courseId}`);
  };

  return (
    <div className="listview"> 
      <div className="card mb-2" style={{ border: 'none', display: 'flex', flexDirection: 'row', height: '200px' }}> 
        {/* Image section */}
        <div className="col-md-4 col-sm-12" style={{ padding: '0', overflow: 'hidden' }}>
          <img 
            src={props.cover_img || catalog} 
            className="img-fluid" 
            alt="Course Thumbnail" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
              borderRadius: '8px 0 0 8px'
            }}
            onError={(e) => {
              e.target.src = catalog;
            }}
          />
        </div>

        {/* Content section */}
        <div className="col-md-8 col-sm-12 cat2card-body" style={{ padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div>
            <h5 className="cat2card-title" style={{ 
              color: '#2C3E50', 
              fontWeight: '600', 
              marginBottom: '10px',
              fontSize: '18px'
            }}>
              {props.coursetitle}
            </h5>
            
            <p className="card-description" style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              color: '#666',
              marginBottom: '8px',
              fontSize: '14px'
            }}>
              {props.description}
            </p>
            
            <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '10px' }}>
              {props.category && (
                <span style={{
                  backgroundColor: '#FFF0E6',
                  color: '#f4811e',
                  fontSize: '12px',
                  fontWeight: '500',
                  padding: '4px 8px',
                  borderRadius: '6px'
                }}>
                  {props.category}
                </span>
              )}
              
              <p className="card-date" style={{ 
                color: '#666', 
                fontSize: '13px', 
                margin: '0',
                display: 'flex',
                alignItems: 'center'
              }}>
                📅 {props.start_date}
              </p>
            </div>

            <p className="card-instructor" style={{ 
              color: '#666', 
              fontSize: '13px', 
              marginBottom: '0' 
            }}>
              <strong style={{ color: '#B8529E' }}>Instructor:</strong> {props.instructor}
            </p>
          </div>

          {/* Action buttons */}
          <div className="cbutton d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {/* Price */}
              <span style={{ 
                color: '#f4811e', 
                fontWeight: '700',
                fontSize: '16px'
              }}>
                {props.price === 0 || props.price === "$0" ? "FREE" : `₹${props.price}`}
              </span>
              
              {/* View Course Button */}
              <button 
                className="btn-shared"
                onClick={viewCourse}
                style={{
                  backgroundColor: '#B8529E',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#9a3a7f';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#B8529E';
                  e.target.style.transform = 'translateY(0)';
                }}
              > 
                View Course
              </button>
            </div>
            
            {/* Wishlist Button */}
            <div style={{ marginLeft: 'auto' }}>
              <WishlistButton 
                courseId={props.courseId}
                isWishlisted={props.isWishlisted}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}